import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=9920fdba&scoped=true"
import script from "./TaskIndex.vue?vue&type=script&lang=js"
export * from "./TaskIndex.vue?vue&type=script&lang=js"
import style0 from "./TaskIndex.vue?vue&type=style&index=0&id=9920fdba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9920fdba",
  null
  
)

export default component.exports